// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Ir-z","tooltipWrapper":"Jr-z","icon":"Kr-z","tooltip":"Lr-z","content":"Mr-z"};